import React from 'react';
import { Chip } from '@mui/material';

// Monochromatic status styles for dbrand-inspired design
// Dark backgrounds with colored left border accent
const statusStyles = {
  // Common statuses
  active: { accent: '#22c55e', text: '#22c55e' },
  inactive: { accent: '#525252', text: '#737373' },
  
  // Ticket statuses
  open: { accent: '#ef4444', text: '#ef4444' },
  in_progress: { accent: '#3b82f6', text: '#3b82f6' },
  waiting_client: { accent: '#eab308', text: '#eab308' },
  waiting_vendor: { accent: '#f97316', text: '#f97316' },
  resolved: { accent: '#22c55e', text: '#22c55e' },
  closed: { accent: '#525252', text: '#737373' },
  
  // Priority
  low: { accent: '#22c55e', text: '#22c55e' },
  medium: { accent: '#3b82f6', text: '#3b82f6' },
  high: { accent: '#f97316', text: '#f97316' },
  critical: { accent: '#ef4444', text: '#ef4444' },
  
  // Project statuses
  planning: { accent: '#8b5cf6', text: '#8b5cf6' },
  on_hold: { accent: '#eab308', text: '#eab308' },
  completed: { accent: '#22c55e', text: '#22c55e' },
  cancelled: { accent: '#525252', text: '#737373' },
  
  // Invoice statuses
  draft: { accent: '#525252', text: '#737373' },
  sent: { accent: '#3b82f6', text: '#3b82f6' },
  viewed: { accent: '#8b5cf6', text: '#8b5cf6' },
  paid: { accent: '#22c55e', text: '#22c55e' },
  partial: { accent: '#f97316', text: '#f97316' },
  overdue: { accent: '#ef4444', text: '#ef4444' },
  
  // Quote statuses
  accepted: { accent: '#22c55e', text: '#22c55e' },
  declined: { accent: '#ef4444', text: '#ef4444' },
  expired: { accent: '#525252', text: '#737373' },
  converted: { accent: '#3b82f6', text: '#3b82f6' },
  pending: { accent: '#eab308', text: '#eab308' },
  // Quote stage (computed server-side from invoice/project associations)
  deposit_invoiced: { accent: '#eab308', text: '#eab308' },
  deposit_paid: { accent: '#22c55e', text: '#22c55e' },
  project_active: { accent: '#3b82f6', text: '#3b82f6' },
  invoiced: { accent: '#8b5cf6', text: '#8b5cf6' },
  balance_due: { accent: '#f97316', text: '#f97316' },
  
  // Backup statuses
  running: { accent: '#3b82f6', text: '#3b82f6' },
  failed: { accent: '#ef4444', text: '#ef4444' },
  imported: { accent: '#8b5cf6', text: '#8b5cf6' },

  // Backup types
  full: { accent: '#3b82f6', text: '#3b82f6' },
  database: { accent: '#22c55e', text: '#22c55e' },
  media: { accent: '#f97316', text: '#f97316' },

  // Client types
  business: { accent: '#3b82f6', text: '#3b82f6' },
  individual: { accent: '#22c55e', text: '#22c55e' },
  charity: { accent: '#ec4899', text: '#ec4899' },
  government: { accent: '#8b5cf6', text: '#8b5cf6' },
  prospect: { accent: '#f97316', text: '#f97316' },
  archived: { accent: '#525252', text: '#737373' }
};

const StatusChip = ({ status, size = 'small', variant = 'default' }) => {
  const normalizedStatus = status?.toLowerCase().replace(/ /g, '_');
  const style = statusStyles[normalizedStatus] || { accent: '#525252', text: '#737373' };
  
  // Format label: replace underscores with spaces
  const label = status?.replace(/_/g, ' ') || '';
  
  if (variant === 'dot') {
    // Minimal dot variant - just a colored dot and text
    return (
      <Chip
        label={label}
        size={size}
        icon={
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: 0,
              backgroundColor: style.accent,
              marginLeft: 8,
              marginRight: -2
            }}
          />
        }
        sx={{
          bgcolor: 'transparent',
          color: style.text,
          fontWeight: 600,
          textTransform: 'uppercase',
          border: 'none',
          px: 0,
          '& .MuiChip-label': {
            px: 0.75
          }
        }}
      />
    );
  }
  
  // Default variant - bordered chip with left accent
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: 'rgba(255,255,255,0.02)',
        color: style.text,
        border: '1px solid',
        borderColor: 'rgba(255,255,255,0.08)',
        borderLeftColor: style.accent,
        borderLeftWidth: 2,
        fontWeight: 600,
        textTransform: 'uppercase',
        '& .MuiChip-label': {
          px: 1
        }
      }}
    />
  );
};

export default StatusChip;
